import { SWRConfig } from 'swr';

const ONE_MINUTE = 60000;

export const SwrProvider = ({ children }: any) => {
  return (
    <SWRConfig
      value={{
        shouldRetryOnError: process.env.NODE_ENV === 'development',
        focusThrottleInterval: ONE_MINUTE,
        keepPreviousData: true,
        onError: (err) => {
          return {
            message: err?.message,
            status: err?.response?.status,
            err,
          };
        },
      }}
    >
      {children}
    </SWRConfig>
  );
};
